// =============================================================================
// Ngữ cảnh "quản trị viên đang sửa hồ sơ HỘ một ứng viên".
//
// CỐ Ý tách hẳn khỏi profileReducer. Không được mượn profileReducer.profile làm
// nơi chứa ứng viên đang sửa, vì:
//   - upsertProfile khi thành công dispatch UPSERT_PROFILE_SUCCESS và GHI ĐÈ
//     profileReducer.profile -> sau khi admin lưu hộ, cả app sẽ tưởng admin
//     chính là ứng viên đó (upload file, lưu hồ sơ... đều trỏ sai chỗ).
//   - AppLayout tự nạp lại profile của người đăng nhập khi thấy nó trống.
// =============================================================================

export const ADMIN_EDITING_TYPE = {
  SET_TARGET: 'ADMIN_EDITING_SET_TARGET',
  CLEAR_TARGET: 'ADMIN_EDITING_CLEAR_TARGET',
  LOADING: 'ADMIN_EDITING_LOADING',
  FAILURE: 'ADMIN_EDITING_FAILURE',
};

const initialState = {
  loading: false,
  // Profile của ứng viên đang được sửa hộ; null = không ở chế độ sửa hộ.
  targetProfile: null,
};

export function adminEditingReducer(state = initialState, action) {
  switch (action.type) {
    case ADMIN_EDITING_TYPE.LOADING:
      return { ...state, loading: true };

    case ADMIN_EDITING_TYPE.SET_TARGET:
      return { ...state, targetProfile: action.payload, loading: false };

    case ADMIN_EDITING_TYPE.FAILURE:
      return { ...state, targetProfile: null, loading: false };

    case ADMIN_EDITING_TYPE.CLEAR_TARGET:
      return initialState;

    default:
      return state;
  }
}
